/* 90'S HOME v2 — trang danh mục: bộ lọc, sắp xếp, bảng trượt, "Xem thêm".
   Lọc bằng Section Rendering API (?section_id=) nên không tải lại cả trang. */
(function () {
  var SEL = '[data-v2-coll]';
  var ctrl = null;

  function root() { return document.querySelector(SEL); }

  function paramsFromForm(form) {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) {
      if (k === 'v2price') {
        if (!v) return;
        var ab = String(v).split('-');
        if (ab[0]) p.append('filter.v.price.gte', ab[0]);
        if (ab[1]) p.append('filter.v.price.lte', ab[1]);
        return;
      }
      if (v !== '') p.append(k, v);
    });
    var hid = form.querySelector('input[name="sort_by"]');
    if (hid && hid.value === hid.dataset.default) p.delete('sort_by');
    return p;
  }

  function openSheet(r, name) {
    r.dataset.sheet = name;
    document.documentElement.style.overflow = 'hidden';
  }
  function closeSheet(r) {
    delete r.dataset.sheet;
    document.documentElement.style.overflow = '';
  }

  function render(url) {
    var r = root();
    if (!r) return;
    var u = new URL(url, location.origin);
    u.searchParams.delete('page');
    u.searchParams.set('section_id', r.dataset.section);
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    r.classList.add('is-loading');
    fetch(u.toString(), ctrl ? { signal: ctrl.signal } : {})
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(SEL);
        if (!fresh) { location.href = url; return; }
        var sheet = r.dataset.sheet || '';
        var body = r.querySelector('.v2-filters__body');
        var st = body ? body.scrollTop : 0;
        var chips = r.querySelector('.v2-ctool__chips');
        var cx = chips ? chips.scrollLeft : 0;
        fresh.classList.add('no-anim');
        if (sheet) fresh.dataset.sheet = sheet;
        r.replaceWith(fresh);
        var nb = fresh.querySelector('.v2-filters__body');
        if (nb) nb.scrollTop = st;
        var nc = fresh.querySelector('.v2-ctool__chips');
        if (nc) nc.scrollLeft = cx;
        requestAnimationFrame(function () { requestAnimationFrame(function () { fresh.classList.remove('no-anim'); }); });
        u.searchParams.delete('section_id');
        history.replaceState({}, '', u.pathname + (u.search ? u.search : ''));
        bind(fresh);
        window.dispatchEvent(new Event('scroll'));
      })
      .catch(function (e) { if (e.name !== 'AbortError') location.href = url; });
  }

  function apply(form) {
    var p = paramsFromForm(form);
    render(form.getAttribute('action') + (p.toString() ? '?' + p.toString() : ''));
  }

  function loadMore(btn) {
    var r = root();
    var next = btn.dataset.next;
    if (!next || btn.dataset.busy) return;
    btn.dataset.busy = '1';
    btn.style.opacity = '.6';
    var u = new URL(next, location.origin);
    u.searchParams.set('section_id', r.dataset.section);
    fetch(u.toString())
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = r.querySelector('[data-v2-grid]');
        var ng = doc.querySelector('[data-v2-grid]');
        if (grid && ng) {
          var base = grid.children.length;
          Array.prototype.slice.call(ng.children).forEach(function (c, i) {
            c.dataset.lag = String(base + i);
            grid.appendChild(c);
          });
        }
        var more = r.querySelector('[data-v2-more]');
        var nm = doc.querySelector('[data-v2-more]');
        if (more && nm) more.replaceWith(nm); else if (more) more.remove();
        window.dispatchEvent(new Event('scroll'));
      })
      .catch(function () { location.href = next; });
  }

  function bind(r) {
    if (!r || r.dataset.bound) return;
    r.dataset.bound = '1';
    var form = r.querySelector('[data-v2-form]');

    /* Khoảng giá: bấm lại mức đang chọn = bỏ chọn */
    r.querySelectorAll('input[name="v2price"]').forEach(function (inp) {
      inp.addEventListener('pointerdown', function () { inp.dataset.was = inp.checked ? '1' : ''; });
      inp.closest('label').addEventListener('pointerdown', function () { inp.dataset.was = inp.checked ? '1' : ''; });
      inp.addEventListener('click', function () {
        if (inp.dataset.was === '1') { inp.checked = false; inp.dataset.was = ''; apply(form); }
      });
    });

    if (form) {
      form.addEventListener('change', function () { apply(form); });
      form.addEventListener('submit', function (e) { e.preventDefault(); apply(form); });
    }

    r.addEventListener('click', function (e) {
      var t = e.target;
      var el;
      if ((el = t.closest('[data-open]'))) { openSheet(r, el.dataset.open); return; }
      if ((el = t.closest('[data-close]'))) {
        closeSheet(r);
        if (el.hasAttribute('data-to-grid')) {
          var res = r.querySelector('.v2-results');
          if (res) window.scrollTo({ top: res.getBoundingClientRect().top + window.scrollY - 180, behavior: 'smooth' });
        }
        return;
      }
      if ((el = t.closest('[data-toggle]'))) {
        var cb = document.getElementById(el.dataset.toggle);
        if (cb && !cb.disabled) { cb.checked = !cb.checked; apply(form); }
        return;
      }
      if ((el = t.closest('[data-sort]'))) {
        var hid = form && form.querySelector('input[name="sort_by"]');
        if (hid) hid.value = el.dataset.sort;
        closeSheet(r);
        apply(form);
        return;
      }
      if ((el = t.closest('[data-sortdd]'))) {
        var dd = el.closest('.v2-sortdd');
        var open = !dd.classList.contains('is-open');
        dd.classList.toggle('is-open', open);
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if ((el = t.closest('[data-next]'))) { e.preventDefault(); loadMore(el); return; }
      if ((el = t.closest('a[data-v2-link]'))) { e.preventDefault(); render(el.href); return; }
    });
  }

  document.addEventListener('click', function (e) {
    var dd = document.querySelector('.v2-sortdd.is-open');
    if (dd && !dd.contains(e.target)) dd.classList.remove('is-open');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var r = root();
    if (r && r.dataset.sheet) closeSheet(r);
    var dd = document.querySelector('.v2-sortdd.is-open');
    if (dd) dd.classList.remove('is-open');
  });

  function init() { bind(root()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
